import React from 'react';

import Header from '../../components/header';
import Footer from '../../components/footer';
import Cards from '../../components/cards';
import imgA1 from '../../assets/contrato.svg';
import imgA3 from '../../assets/token.svg';
import './styles.css';

export default function Options() {
  return (
    <>
      <Header content="Escolha uma das opções abaixo" />
      <div className="options-container">
        <Cards
          imgCard1={imgA1}
          spanCard1="A1"
          linkCard1="/a1"
          imgCard2={imgA3}
          spanCard2="A3"
          linkCard2="/a3"
        />
      </div>
      <Footer />
    </>
  );
}
